import { render } from "./BaseAlert.vue?vue&type=template&id=ecf37eba&ts=true"
import script from "./BaseAlert.vue?vue&type=script&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__